<template>
  <div class="bg-white shadow p-3">
    <div class="d-flex justify-content-between align-items-top mb-3">
      <div>
        <h2 class="mb-0">API Keys</h2>
        <small class="text-muted">Hier können Sie Ihre API-Schlüssel verwalten.</small>
      </div>

      <div>
        <CreateApiKeyModal />
      </div>
    </div>

    <div v-if="loading" class="text-center">
      <LoadingSpinner />
    </div>

    <div v-else>
      <div v-if="apiKeys.length === 0" class="alert alert-info">Sie haben noch keine API-Schlüssel. Bitte erstellen Sie einen neuen Schlüssel.</div>

      <div v-else>
        <ApiKeyRow v-for="key in apiKeys" :key="key.id" :api-key="key" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onMounted } from 'vue';

  import { useAuthStore } from '@/stores/authStore';
  import { useCommonStore } from '@/stores/commonStore';

  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  import CreateApiKeyModal from './CreateApiKeyModal.vue';
  import ApiKeyRow from './ApiKeyRow.vue';
  //#endregion

  const authStore = useAuthStore();
  const commonStore = useCommonStore();

  const loading = computed(() => commonStore.status.getApiKeysLoading || commonStore.status.deleteApiKeysLoading);
  const apiKeys = computed(() => authStore.apiKeys);

  onMounted(() => {
    if (apiKeys.value.length === 0) {
      authStore.getAllApiKeys();
    }
  });
</script>
